import api from './api';

export interface GrupoMcpUsuario {
    grupoMcp: number;
    usuario: string;
    [key: string]: any;
}

export interface User {
    id: string;
    username: string;
    password?: string;
    email: string;
    role: string;
    createdAt?: string;
    lastLogin?: string;
}

const grupoMcpUsuarioService = {
    getGruposMcpUsuarios: async (): Promise<GrupoMcpUsuario[]> => {
        const response = await api.get<GrupoMcpUsuario[]>('/api/GrupoMcpUsuario');
        return response.data;
    },

    createGrupoMcpUsuario: async (grupoMcpUsuario: GrupoMcpUsuario): Promise<GrupoMcpUsuario> => {
        const response = await api.post<GrupoMcpUsuario>('/api/GrupoMcpUsuario', grupoMcpUsuario);
        return response.data;
    },

    getGrupoMcpUsuario: async (grupoMcp: number, usuario: string): Promise<GrupoMcpUsuario> => {
        const response = await api.get<GrupoMcpUsuario>(`/api/GrupoMcpUsuario/${grupoMcp}/${usuario}`);
        return response.data;
    },

    deleteGrupoMcpUsuario: async (grupoMcp: number, usuario: string): Promise<void> => {
        await api.delete(`/api/GrupoMcpUsuario/${grupoMcp}/${usuario}`);
    },

    getUsuariosByGrupo: async (grupoMcp: number): Promise<GrupoMcpUsuario[]> => {
        const response = await api.get<GrupoMcpUsuario[]>(`/api/GrupoMcpUsuario/grupo/${grupoMcp}`);
        return response.data;
    },

    getGruposByUsuario: async (usuario: string): Promise<GrupoMcpUsuario[]> => {
        const response = await api.get<GrupoMcpUsuario[]>(`/api/GrupoMcpUsuario/usuario/${usuario}`);
        return response.data;
    },

    getLookup: async (): Promise<any> => {
        const response = await api.get<any>('/api/GrupoMcpUsuario/lookup');
        return response.data;
    },

    getUsers: async (): Promise<User[]> => {
        const response = await api.get<User[]>('/api/Users');
        return response.data;
    }
};

export default grupoMcpUsuarioService;

